// ICSP-59: a tiny presentation-only flag so the app chrome (the bottom nav
// in routes.tsx) can hide the navigation bar while the AdultGate
// interstitial is up — the user isn't "in" yet, so the nav must not show.
//
// Context + hooks live here (no component, so this stays a plain .ts and
// doesn't trip react-refresh/only-export-components); the provider
// component is in AdultGateProvider.tsx. Both the writer (AdultGate, a
// RequireAuth child) and the reader (AnimatedLayout, the parent layout)
// import from here without a circular dependency — same rationale that put
// ROUTES in paths.ts. This flag carries NO clinical decision; the gate's
// adult-declaration logic is unchanged and still lives in AdultGate.tsx.

import { createContext, useContext } from "react";

export interface AdultGateState {
  /** True while the AdultGate interstitial (or its loading state) is shown. */
  gated: boolean;
  setGated: (gated: boolean) => void;
}

// Default `gated: false` is the fail-safe: with no provider mounted, the
// nav shows on its allow-listed routes rather than disappearing.
export const AdultGateContext = createContext<AdultGateState>({
  gated: false,
  setGated: () => {},
});

/** Read the flag — used by the chrome to decide whether to show the nav. */
export function useAdultGate(): boolean {
  return useContext(AdultGateContext).gated;
}

/** Publish the flag — used by AdultGate to report whether it is gating. */
export function useSetAdultGate(): (gated: boolean) => void {
  return useContext(AdultGateContext).setGated;
}
